export type THighlightPart = {
  id: string;
  text: string;
  match: boolean;
};

export const getHighlightedParts = (
  text: string,
  query: string
): THighlightPart[] => {
  if (!query) return [{ id: "0", text, match: false }];

  const regex = new RegExp(`(${query})`, "i");
  return text.split(new RegExp(`(${query})`, "ig")).map((part, i) => ({
    id: `${i}`,
    text: part,
    match: regex.test(part),
  }));
};
